import { defineStore, storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import type { PermissionType, UserInformation, UserPermissionData } from 'src/types/user.types';
import { useApi } from './useApis';
import { createApiMap } from 'src/services/apiMap';
import { useGlobalSearchStore } from '.';

export const useUserStore = defineStore('user', () => {
    const { makeRequest } = useApi();
    const userInformation = ref<UserInformation | undefined>();
    const userConfig = ref<UserInformation | undefined>();
    const userPermission = ref<Partial<Record<PermissionType, boolean>> | undefined>();
    const globalSearchStore = useGlobalSearchStore();
    const { wsUserRootRoleId } = storeToRefs(globalSearchStore);
    const wsUserRoles = ref<any | undefined>();
    const apiMap = createApiMap();
    const wsInformation = ref<any | undefined>();
    const getUserData = async (): Promise<UserInformation> => {
        const getDataConfig = apiMap.getUserInformation(undefined);
        const res = await makeRequest(getDataConfig);
        userInformation.value = res;
        return res;
    };
    const getWsInformation = async (): Promise<UserInformation> => {
        const getDataConfig = apiMap.getWsInformation(undefined);
        const res = await makeRequest(getDataConfig);
        wsInformation.value = res.data[0];
        wsUserRoles.value = res.data[0].ws_user_role_id;
        await getUserRootRole(res.data[0].ws_user_role_id);
        return res;
    };

    const getUserConfig = async (): Promise<UserInformation> => {
        const getDataConfig = apiMap.getUserConfig(undefined);
        const res = await makeRequest(getDataConfig);
        userConfig.value = res;
        return res;
    };

    const getUserPermission = async (): Promise<UserPermissionData> => {
        const getDataConfig = apiMap.getUserPermission(undefined);
        const res = await makeRequest(getDataConfig);
        userPermission.value = Object.fromEntries(res.map((item: UserPermissionData) => [item, true]));
        return res;
    };
    const getUserRootRole = async (id: string): Promise<string | undefined> => {
        const getDataConfig = apiMap.getUserRootRole(id);
        const res = await makeRequest(getDataConfig);
        wsUserRootRoleId.value = res.ws_role.ws_root_role_id;
        // userPermission.value = Object.fromEntries(res.map((item: UserPermissionData) => [item, true]));
        return res;
    };

    const getUserInformation = async (): Promise<void> => {
        await Promise.all([getUserData(), getUserPermission(), getUserConfig()]);
    };
    const checkFlag = true; // This should be replaced with actual logic to determine if the user has permission
    // to access the user interface features
    const userPermissionConfig = computed(() => {
        return {
            canOpenReview: checkFlag && userPermission.value?.media_getReviewUserInterface_read == true,
            canOpenProject: checkFlag && userPermission.value?.project_getProjectDirectoryUserInterface_read == true,
            canOpenSceneHub: true,
            canOpenPeopleInsight: checkFlag && userPermission.value?.peopleTile_getInsightsInterface_read == true,
            canOpenPeopleDetail: checkFlag && userPermission.value?.people_getListOfWorkspaceUsers_read == true,
            canOpenTakeUpdate: checkFlag && userPermission.value?.update_getUpdateUserInterface_read == true,
            canOpenTakeWoohoo: checkFlag && userPermission.value?.woohoo_getWoohooUserInterface_read == true
        };
    });
    return {
        userInformation,
        userPermission,
        userPermissionConfig,
        getUserInformation,
        getUserConfig,
        getWsInformation
    };
});
